
import Vue from 'vue';
import { format, parse } from 'date-fns';
import Calendar from '@/uikit/components/AppSvgIcon/iconsTemplate/contents/calendar.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';

export default Vue.extend({
  name: 'ScheduleDate',
  components: { AppSvgIcon, Calendar },
  props: {
    scheduleFrom: String,
    scheduleTo: String,
  },
  methods: {
    parseDate(date: string) {
      return format(parse(date), 'DD.MM.YYYY');
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/components/ScheduleDate.vue